import { forwardRef } from "react"
import { memo } from "react"
import styled, { css } from "styled-components"

import SVGIcon from "components/modules/common/SVGIcon"

export default memo(
  forwardRef(function CheckBox(
    { type = "checkbox", id, children, checked, isCircle, errorMsg, ...rest },
    ref
  ) {
    return (
      <>
        <CheckBoxBlock>
          <Label htmlFor={id}>
            <HideInput type={type} ref={ref} id={id} checked={checked} {...rest} />
            <CheckBoxStyle checked={checked} isCircle={isCircle}>
              {checked && (
                <CheckIconBlock>
                  <SVGIcon name="check" />
                </CheckIconBlock>
              )}
            </CheckBoxStyle>
          </Label>
          {children && children}
        </CheckBoxBlock>
        {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
      </>
    )
  })
)

const CheckBoxBlock = styled.div`
  display: flex;
  align-items: flex-start;
`

const Label = styled.label`
  position: relative;
`

const HideInput = styled.input`
  position: absolute;
  display: none;
`

const CheckBoxStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100vw * (18 / 375));
  height: calc(100vw * (18 / 375));
  border: 1px solid #7f7f7f;
  border-radius: calc(100vw * (3 / 375));
  background-color: #fff;

  ${({ checked }) =>
    checked &&
    css`
      border: 1px solid #000;
      background-color: #000;
    `}

  ${({ isCircle }) =>
    isCircle &&
    css`
      border-radius: 100%;
    `}
`

const CheckIconBlock = styled.div`
  width: calc(100vw * (11 / 375));
  height: calc(100vw * (13 / 375));

  svg {
    color: #fff;
  }
`
const ErrorMsg = styled.span`
  display: block;
  font-size: calc(100vw * (11 / 375));
  font-weight: 400;
  line-height: calc(100vw * (16 / 375));
  color: #de0000;
  margin-top: calc(100vw * (5 / 375));
`
